import React from 'react';
import { Logo } from './Logo';
import { Cta } from './Cta';
import { useScore } from './ScoreContext';
export function Nav() {
  const {
    answeredCount,
    openDiagnostic
  } = useScore();
  const shortLabel = answeredCount === 0 ? 'Get Your Score' : answeredCount < 4 ? 'Continue Score' : 'Finish Score';
  const fullLabel = answeredCount === 0 ? 'Get Your Reader-to-Revenue Score' : answeredCount < 4 ? 'Continue Your Score' : 'Finish Your Score';
  return <header className="site-header sticky top-0 z-40 w-full border-b border-gray-100 bg-paper/80 shadow-sm backdrop-blur-md" data-id="element-327" data-mp="1fxuted4vq2el">
      <div className="site-header-inner mx-auto flex w-full max-w-[90rem] items-center justify-between gap-3 px-4 py-3 sm:px-6 md:px-10 md:py-5" data-id="element-328" data-mp="1ppqp5hjhtgfn">
        <Logo className="min-w-0 shrink-0" data-id="element-329" data-mp="1uo24g7sk4j59" />
        <nav aria-label="Primary" data-id="element-330" data-mp="1yqgk6j0xj2sb">
          <Cta variant="primary" size="sm" onClick={openDiagnostic} aria-label={fullLabel} className="min-h-[44px] shrink-0 whitespace-nowrap px-3.5 shadow-sm hover:shadow sm:px-5" data-id="element-331" data-mp="1yr88r9w40093">
            <span className="sm:hidden" data-id="element-332" data-mp="1y6707e5smq6v">{shortLabel}</span>
            <span className="hidden sm:inline" data-id="element-333" data-mp="1y3lwejlxq06h">{fullLabel}</span>
          </Cta>
        </nav>
      </div>
    </header>;
}